module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "Slide"
  }, [_c('section', [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_support-header.svg"),
      "alt": "児童家庭支援事業"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("様々な環境で暮らす子どもたちを、"), _c('br', {
    staticClass: "visible-sm"
  }), _vm._v("地域の関係機関が"), _c('br'), _vm._v("繋がりながら支援しています。")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_support.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_supportlist001.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("まちこや")]), _vm._v(" "), _c('p', [_vm._v("開催場所：山代老人児童センター内"), _c('br'), _vm._v("開催日時：第1・第3土曜日 午前10時30分～11時30分読み書き・そろばんの基本的なことや、大学生や中学生が、理科の実験や外国語などを通じて、知ることはワクワクドキドキ！を教えてくれます。")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_supportlist002.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("よりみちハウス")]), _vm._v(" "), _c('p', [_vm._v("開催場所：石川県加賀市山代温泉山背台　寄り道ハウス内"), _c('br'), _vm._v("\n          開催日時：学校課業日　月・水・金　午後3時～5時"), _c('br'), _vm._v("\n          子どもたちが学校の帰り、宿題をしながら、町のおじちゃん、おばちゃんが話し相手になってくれます。")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_supportlist003.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("山代の子どもを育てる会")]), _vm._v(" "), _c('p', [_vm._v("開催場所：石川県加賀市山代温泉北部1-233"), _c('br'), _vm._v("\n            開催日時：毎月第4月曜日　午後1時30分"), _c('br'), _vm._v("\n            子どもたちを取り巻く様々な機関が一堂に集まり、子どもたちの現状について情報交換をし、ゆるく繋がることで、情報の共有をします。")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f79d6a5!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SupportSlide.vue
// module id = 383
// module chunks = 2